import React from 'react';
import { useSelector } from 'react-redux';

import * as lessonSelectors from 'common.components/lesson/selectors';

import { CustomLessonView } from './custom-lesson-view';

export const CustomLessonViewContainer = () => {
    const landingSrc = useSelector(lessonSelectors.getCustomLessonViewLandingSrc);

    return <CustomLessonView landingSrc={landingSrc} />;
};
